export function ApplicationNotQualified() {
  return (
    <div className='w-full h-full flex flex-col items-center justify-center px-4 py-6 gap-4 mt-10'>
      <p className='lg:text-5xl text-4xl font-bold text-red-700'>Sorry.</p>
      <p className='lg:text-2xl text-xl font-bold'>Based on your answers, you do not qualify for the Self Employed Tax Refund Credit.</p>
    </div>
  )
}